import React from "react"

const About = () => {
  return <div className="about-message">
   <h1>about page</h1>
   <h2>React tutorial</h2>
    </div>
}
export default About